import { ActionTree, Commit } from 'vuex';
import { IState } from './state';
import config from '@/params/config';
import * as TYPES from './types';
import { apiFetchAction } from '../apiUtil';

// const apiRoot: string = `${config.neo}/${config.apiVersion}`;
const apiRoot: string = config.neo;

interface IActionContent {
  state: IState;
  commit: Commit;
}

// 查询目录列表
const getCategory = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Config/GetSystemConfig',
    'GET',
    TYPES.CATEGORY,
    payload,
    false,
    apiRoot
  );
};

// 查询目录列表
const getBackProductDocDTO = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Config/GetBackProductDocDTO',
    'GET',
    TYPES.PRODUCTCATEGORY,
    payload,
    false,
    apiRoot
  );
};

// 查询目录列表
const getBackProductDocDTOById = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Config/GetBackProductDocDTOById',
    'GET',
    TYPES.IDPRODUCTCATEGORY,
    payload,
    false,
    apiRoot
  );
};

// 查询目录列表
const setBackProductDocDTOById = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Config/SetBackProductDocById',
    'POST',
    TYPES.IDPRODUCTCATEGORYMESSAGE,
    payload,
    false,
    apiRoot
  );
};

// 查询目录列表
const getDoccatalog = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'FileCloud/GetDocCenterTree',
    'GET',
    TYPES.DOCCATALOG,
    payload,
    false,
    apiRoot
  );
};
// 查询文档token
const getDocToken = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'FileCloud/GetAccessToken',
    'GET',
    TYPES.DOC_TOKEN,
    payload,
    false,
    apiRoot
  );
};

// 查询文档服务URL
const getDocUrl = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'FileCloud/GetOssApiUrl',
    'GET',
    TYPES.DOC_OSSURL,
    payload,
    false,
    apiRoot
  );
};

// 查询文档下载地址
const getDocDownload = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'FileCloud/GetDownloadUrl',
    'GET',
    TYPES.DOC_DOWNLOAD,
    payload,
    false,
    apiRoot
  );
};
// 查询文档浏览量
const getDocInfo = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'FileCloud/GetDocumentInfo',
    'GET',
    TYPES.DOC_INFO,
    payload,
    false,
    apiRoot
  );
};
// 公告详情 -- 公告点赞
const praiseDoc = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'FileCloud/PraiseDocumentById',
    'GET',
    TYPES.PRAISE_DOC_META,
    payload,
    false,
    apiRoot
  );
};

// 公告详情 -- 公告取消点赞
const cancelPraiseDoc = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'FileCloud/DocumentPraiseCancelById',
    'GET',
    TYPES.CANCEL_PRAISE_DOC_META,
    payload,
    false,
    apiRoot
  );
};
// 获取首页文档子级目录
const getHomelist = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'FileCloud/GetFolderFiles',
    'POST',
    TYPES.DOC_HOMELIST,
    payload,
    false,
    apiRoot
  );
};
// 获取首页文档父级目录
const getHomelistPar = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Config/GetListProductDocDTO',
    'GET',
    TYPES.DOC_HOMELIST_PAR,
    payload,
    false,
    apiRoot
  );
};
// 文档已浏览
const setDocViewed = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'FileCloud/DocumentViewById',
    'GET',
    TYPES.DOC_VIEWED,
    payload,
    false,
    apiRoot
  );
};

// 获取搜索热词
const getHotWords = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Search/GetSearchKeys',
    'GET',
    TYPES.HOT_WORDS,
    payload,
    false,
    apiRoot
  );
};
// 获取搜索热词
const getSysList = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'FileCloud/GetProductVersion',
    'GET',
    TYPES.SYS_LIST,
    payload,
    false,
    apiRoot
  );
};

export const actions = {
  getCategory,
  getBackProductDocDTO,
  getBackProductDocDTOById,
  setBackProductDocDTOById,
  getDoccatalog,
  getDocToken,
  getDocUrl,
  getDocDownload,
  getDocInfo,
  praiseDoc,
  cancelPraiseDoc,
  getHomelistPar,
  getHomelist,
  setDocViewed,
  getHotWords,
  getSysList
};
